import { v4 as uuidv4 } from "uuid";
export class ClockWorkAnalyticsRequestModel {
    constructor() {
        this.id = uuidv4();
        this.startDate = null;
        this.endDate = null;
        this.startDateAsString = "";
        this.endDateAsString = "";
        this.teamId = [];
    }
}
export default class ClockWorkAnalyticsRequest extends ClockWorkAnalyticsRequestModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
